// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { createWidgetElement } from "@insite/client-framework/Components/ContentItemStore";
import { LinkPresentationProps } from "@insite/mobius/Link";

interface OwnProps {
    title: string;
    wishListId: string;
    testSelector: string;
    // XNG-Change
    extendedStyles?: LinkPresentationProps;
    onClick?: () => void;
}

type Props = OwnProps;

const MyListsDetailsPageTypeLink: React.FunctionComponent<Props> = ({
    title,
    wishListId,
    testSelector,
    extendedStyles,
    // XNG-Change: google analytics
    onClick,
}) => {
    return createWidgetElement("Basic/PageTypeLink", {
        fields: {
            testSelector,
            pageType: "MyListsDetailsPage",
            overrideTitle: title,
            queryString: `id=${wishListId}`,
            // XNG-Change
            extendedStyles,
            onClick,
        },
    });
};

export default MyListsDetailsPageTypeLink;
